import { Component, EventEmitter, Input, NgZone, OnInit, OnChanges, Output, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { CSEService } from '../../services/cse.service';
import { OrderService } from '../../services/order.service';
import { NotificationService } from '../../services/notification.service';
import { UtilService } from '../../services/util.service';
import { QuoteOrder, SearchCarrierContract, SearchInvoiceLine, SearchQuoteOrder } from '../../models/models';

@Component({
    selector: 'quoteordermaster-grid',
    templateUrl: './quoteordermaster-grid.component.html',
    standalone: false
})
export class QuoteOrderMasterGrid implements OnInit, OnChanges {
    @Input() billToID: number = 0;
    @Input() quoteOrderID: number = 0;
    @Output() closeCopyOrder = new EventEmitter<any>();

    @ViewChild(GridComponent, { static: false }) public quoteOrderMasterGrid!: GridComponent;
    @ViewChild(GridComponent, { static: false }) public copyLoadGrid!: GridComponent;

    public isEdit: boolean = false;
    public quoteOrderMaster: SearchQuoteOrder = {} as SearchQuoteOrder;
    public quoteOrderMasterList: SearchQuoteOrder[] = [];

    public gridState: State = { skip: 0, take: 5, sort: [{ dir: 'desc', field: 'numOrders' }] };
    public gridData: GridDataResult = { data: [], total: 0 };
    public copyLoadGridState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: 'legNumber' }] };
    public copyLoadGridData: GridDataResult = { data: [], total: 0 };

    private copyLoadRowIndex: number = -1;
    public copyLoadList: SearchCarrierContract[] = [];

    constructor(private cseService: CSEService, private notificationService: NotificationService,
        private orderService: OrderService, private ngZone: NgZone, private utilService: UtilService) { }

    ngOnInit() {
        this.getSearchQuoteOrderMaster();
        //console.log("ngOnInit");
    }

    ngOnChanges() {
        this.getSearchQuoteOrderMaster();
        //console.log("ngOnChanges");
    }

    public getSearchQuoteOrderMaster() {
        this.utilService.isLoading = true;
        this.quoteOrderMaster = {} as SearchQuoteOrder;
        this.quoteOrderMasterList.length = 0;
        if (this.billToID > 0) {
            this.orderService.getSearchQuoteOrderMasterByBillToID(this.billToID).subscribe(result => {
                this.utilService.isLoading = false;
                this.quoteOrderMasterList = result.resultCollection;
                this.setGrid();
                console.log("quoteOrderMasterList:billToID", this.billToID, this.quoteOrderID, this.quoteOrderMasterList.length);
            });
        }
        else if (this.quoteOrderID > 0) {
            this.orderService.getSearchQuoteOrderMasterByQuoteOrderID(this.quoteOrderID).subscribe(result => {
                this.utilService.isLoading = false;
                this.quoteOrderMasterList = result.resultCollection;
                this.setGrid();
                console.log("quoteOrderMasterList:quoteOrderID", this.quoteOrderID, this.quoteOrderID, this.quoteOrderMasterList.length);
            });
        }
        else {
            this.utilService.isLoading = false;
        }
    }

    private getCarrierContracts(quoteOrderID: number) {
        this.utilService.isLoading = true;
        this.copyLoadList.length = 0;
        this.cseService.getSearchCarrierContractByQuoteOrderID(quoteOrderID).subscribe(result => {
            this.utilService.isLoading = false;
            this.copyLoadList = result.resultCollection;
            this.setCopyLoadGrid();
            //console.log("quoteOrderLineList:quoteOrderID", this.quoteOrderID, this.quoteOrderLineList.length);
        });
    }

    private setGrid() {
        this.gridData = process(this.quoteOrderMasterList, this.gridState);
        this.fitColumns();
    }

    private setCopyLoadGrid() {
        this.copyLoadGridData = process(this.copyLoadList, this.copyLoadGridState);
        this.fitCopyLoadColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.quoteOrderMasterGrid == null) return;
            this.quoteOrderMasterGrid.autoFitColumns();
        });
    }

    private fitCopyLoadColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.copyLoadGrid == null) return;
            this.copyLoadGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.gridState = state;
        this.gridData = process(this.quoteOrderMasterList, this.gridState);
    }

    //public addNew() {
    //    var refTable: string = "";
    //    var refTableID: number = 0;
    //    if (this.orderStopID > 0) {
    //        refTable = "stops";
    //        refTableID = this.orderStopID;
    //    }
    //    if (this.quoteOrderID > 0) {
    //        refTable = "quoteorder";
    //        refTableID = this.quoteOrderID;
    //    }
    //    this.quoteOrderMaster = {
    //        referenceNumberId: 0,
    //        erpReferenceNumberId: 0,
    //        referenceTable: refTable,
    //        referenceTableId: refTableID,
    //        createdBy: "Web App",
    //        value: "",
    //        erpReferenceTableKey: 0,
    //        orderNumber: this.orderNumber,
    //        referenceType: "",
    //        referenceTypeID: 0,
    //        createdDate: new Date()
    //    };
    //}

    public onGridDetailCollapse(evt: any) {
        if (this.copyLoadRowIndex >= 0) {
            this.copyLoadGrid.collapseRow(this.copyLoadRowIndex);
        }
        this.copyLoadRowIndex = -1;
        //console.log("onGridDetailCollapse", evt);
    }

    public onGridDetailExpand(evt: any) {
        if (this.copyLoadRowIndex >= 0) {
            this.copyLoadGrid.collapseRow(this.copyLoadRowIndex);
        }
        this.copyLoadRowIndex = evt.index;
        //this.loadCostList = [];
        this.getCarrierContracts(evt.dataItem.quoteOrderID);
        //console.log("onGridDetailExpand", evt);
        //this.getTrackingBoardDetail(evt.dataItem);
    }

    public selectQuoteOrderMaster(quoteOrderMaster: SearchQuoteOrder) {
        //console.log("edit", invoiceLine);
        //this.orderService.getReferenceNumberByID(quoteOrderMaster.referenceNumberID).subscribe(result => {
        //    if (result.resultCollection.length > 0) {
        //        this.quoteOrderMaster = result.resultCollection[0];
        //    }
        //});
        this.utilService.isLoading = true;
        this.orderService.getSearchInvoiceLineByQuoteOrderID(quoteOrderMaster.quoteOrderID).subscribe(result => {
            this.utilService.isLoading = false;
            var invoiceLineList: SearchInvoiceLine[] = result.resultCollection;
            var lhaul = invoiceLineList.find(t => t.abbrev == "LHaul");
            if (lhaul != null && lhaul.invoiceAmount > 0) {
                this.quoteOrderMaster = Object.assign({}, quoteOrderMaster);
            }
            else {
                this.notificationService.showWarning("Invoice Lines Line Haul (LHaul) missing or $0.00.", "WARNING: Copy Order");
            }
        });
    }

    public saveDescription(quoteOrderMaster: SearchQuoteOrder) {
        this.utilService.isLoading = true;
        this.orderService.getQuoteOrderByID(quoteOrderMaster.quoteOrderID).subscribe(result => {
            if (result.resultCollection.length > 0) {
                var quoteOrder: QuoteOrder = result.resultCollection[0];
                console.log("saveDescription", quoteOrder, quoteOrderMaster);
                quoteOrder.description = quoteOrderMaster.orderDescription;
                this.orderService.saveQuoteOrder(quoteOrder).subscribe(result => {
                    this.utilService.isLoading = false;
                    if (result.resultCollection.length > 0) {
                        quoteOrder = result.resultCollection[0];
                        this.getSearchQuoteOrderMaster();
                    } else {
                        this.notificationService.showError("Failed to save order description.", "ERROR: Failed to Save");
                    }
                });
            }
            else {
                this.utilService.isLoading = false;
                this.notificationService.showError("Failed to retrieve order.", "ERROR: Get Order");
            }
        });
    }

//    public delete(refNum: SearchReferenceNumber) {
//        //console.log("edit", invoiceLine);
//        if (confirm("Delete " + refNum.referenceType + " (" + refNum.value + ")?")) {
//            this.orderService.deleteReferenceNumberByID(refNum.referenceNumberID).subscribe(result => {
//                console.log("deleteReferenceNumber", result, refNum);
//                this.getReferenceNumbers();
//            });
//        }
//        //this.refNum = Object.assign({}, invoiceLine);
//    }

    public closeGrid() {
        this.billToID = 0;
        this.quoteOrderID = 0;
        this.closeCopyOrder.emit();
    }
}
